import { render, staticRenderFns } from "./ArbitragePta.vue?vue&type=template&id=8755849e"
import script from "./ArbitragePta.vue?vue&type=script&lang=js"
export * from "./ArbitragePta.vue?vue&type=script&lang=js"
import style0 from "./ArbitragePta.vue?vue&type=style&index=0&id=8755849e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports